// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3-JH9","footer":"ModalUpdate_footer__2IfEc"};